import { useViewContext } from "@editor-providers";
import { useEffect } from "react";
import { useIntersectionObserver } from "usehooks-ts";
import type { ImageProps } from "../types";

const MEDIA_SELECTOR = "[data-animation='true']";

export const useMediaAnimation = ({ settings }: { settings: ImageProps }) => {
  const { view } = useViewContext();
  const isPdf = view === "pdf";
  const { ref, isIntersecting, entry } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
  });

  useEffect(() => {
    if (!isIntersecting || !entry?.target || isPdf) return;

    const media = (entry.target as HTMLDivElement).querySelector(
      MEDIA_SELECTOR,
    );
    media?.setAttribute("data-animation-mode", "animate");
  }, [
    isIntersecting,
    entry,
    isPdf,
    settings.animation,
    settings.animationStyle,
    settings.animationDirection,
    settings.animationType,
  ]);

  return { ref };
};
